import { ArrowUp, PhoneOff } from 'lucide-react';
import { useState } from 'react';

export function Composer({
  onSend,
  onEnd,
  disabled,
}: {
  onSend: (text: string) => void;
  onEnd: () => void;
  disabled: boolean;
}) {
  const [text, setText] = useState('');
  return (
    <form
      className="flex items-center gap-2 rounded-full bg-fg/[0.06] p-1.5 ring-1 ring-fg/10"
      onSubmit={(e) => {
        e.preventDefault();
        onSend(text);
        setText('');
      }}
    >
      <input
        data-testid="composer-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        disabled={disabled}
        placeholder="Talk, or type here…"
        className="min-w-0 flex-1 bg-transparent px-4 py-2 text-[15px] text-fg placeholder:text-subtle focus:outline-none"
      />
      <button
        type="submit"
        data-testid="composer-send"
        disabled={disabled || !text.trim()}
        className="grid size-10 place-items-center rounded-full bg-fg text-bg transition disabled:opacity-25"
        aria-label="Send"
      >
        <ArrowUp className="size-5" />
      </button>
      <button
        type="button"
        data-testid="end-button"
        onClick={onEnd}
        className="grid size-10 place-items-center rounded-full bg-bad/15 text-bad ring-1 ring-bad/30 transition hover:bg-bad/25"
        aria-label="End session"
      >
        <PhoneOff className="size-4" />
      </button>
    </form>
  );
}
